export const dataset = [
  { total: 1, month: "Jan" },
  { total: 2, month: "Feb" },
  { total: 1.5, month: "Mar" },
  { total: 3, month: "Apr" },
  { total: 3.5, month: "May" },
  { total: 2, month: "Jun" },
  { total: 4.4, month: "Jul" },
  { total: 1.2, month: "Aug" },
  { total: 4.9, month: "Sep" },
];
